import has from 'lodash/has';

import saveSearch from '@/store/search/mutations/saveSearch';

export default {
    ...saveSearch,

    SET(state, data) {
        state[data.key] = data.value;
    },

    SET_OBJECT(state, data) {
        state[data.key] = JSON.parse(JSON.stringify(data.value));
        if (data.key === 'searchPayload') {
            if (has(state.searchPayload, 'search_filters.posted_within_days') && state.searchPayload.search_filters.posted_within_days === '') {
                state.searchPayload.search_filters.posted_within_days = state.postedWithIn[0];
            }
            if (has(state.searchPayload, 'search_filters.pay_min.pay_type_code') && state.searchPayload.search_filters.pay_min.pay_type_code) {
                state.searchPayload.search_filters.display_pay_type = state.searchPayload.search_filters.pay_min.pay_type_code;
            }
            if (has(state.searchPayload, 'search_filters.pay_max.pay_type_code') && state.searchPayload.search_filters.pay_max.pay_type_code) {
                state.searchPayload.search_filters.display_pay_type = state.searchPayload.search_filters.pay_max.pay_type_code;
            }

        }
    },

    SET_SEARCH_FILTERS(state, data) {
        if (data.key !== 'page' && data.key !== 'sort_by') {
            state.searchPayload.search_filters.page = 1;
        }

        if (data.key === 'posted_within_days') {
            if (data.value === '') {
                state.searchPayload.search_filters[data.key] = state.postedWithIn[0];
            }
        } else if (data.key === 'search_keywords' || data.key === 'keywords') {
            if (data.value !== '') {
                state.searchPayload.search_filters.search_keywords = data.value;
            }
        } else {
            state.searchPayload.search_filters[data.key] = JSON.parse(JSON.stringify(data.value));
        }

        if (!data.preventSearch) {
            state.emitSearchFilterCount += 1;
        }
    },

    UPDATE_SEARCH_CLASSIFICATION_FILTER(state, data) {
        const { classification, subclassification } = data;

        let newClassification = true;
        const selectedClassifications = state.searchPayload.search_filters?.classifications || [];
        selectedClassifications.forEach((c, index) => {
            if (c.id === classification.id) {
                newClassification = false;
                if (subclassification === null) {
                    selectedClassifications.splice(index, 1);
                } else {
                    let newSubClassification = true;
                    c.subclassifications.forEach((s, index2) => {
                        if (s.id === subclassification.id) {
                            newSubClassification = false;
                            c.subclassifications.splice(index2, 1);
                            if (c.subclassifications.length === 0) {
                                selectedClassifications.splice(index, 1);
                            }
                        }
                    });

                    if (newSubClassification) {
                        c.subclassifications.push({
                            ...subclassification,
                        });
                    }
                }
            }
        });

        if (newClassification) {
            const sub = [];
            if (subclassification) {
                sub.push({
                    ...subclassification,
                });
            }

            selectedClassifications.push({
                ...classification,
                subclassifications: sub,
            });
        }
        state.searchPayload.search_filters.classifications = [...selectedClassifications];
        state.emitSearchFilterCount += 1;
    },

    STORE_SEARCH_FILTER_ATTRIBUTE(state, { key, attributeOption }) {
        if (!state.searchPayload.search_filters[key]) {
            state.searchPayload.search_filters[key] = [];
        }
        const index = state.searchPayload.search_filters[key].findIndex(o => parseInt(o.id) === parseInt(attributeOption.id));
        if (index < 0) {
            state.searchPayload.search_filters.page = 1;
            state.searchPayload.search_filters[key].push(attributeOption);
            state.emitSearchFilterCount += 1;
        } else {
            state.searchPayload.search_filters[key].splice(index, 1);
            state.emitSearchFilterCount -= 1;
        }
    },

    DELETE_SEARCH_FILTER_ATTRIBUTE(state, { key, attributeOption, preventSearch }) {
        const index = state.searchPayload.search_filters[key].findIndex(o => parseInt(o.id) === parseInt(attributeOption.id));
        if (index >= 0) {
            state.searchPayload.search_filters.page = 1;
            state.searchPayload.search_filters[key].splice(index, 1);
            if (!preventSearch) {
                state.emitSearchFilterCount -= 1;
            }
        }
    },

    STORE_SEARCH_TAG(state, { key, value }) {
        const index = state.searchPayload.search_filters[key].findIndex(o => o === value);
        if (index < 0) {
            state.searchPayload.search_filters.page = 1;
            state.searchPayload.search_filters[key].push(value);
            state.emitSearchFilterCount += 1;
        }
    },

    DELETE_SEARCH_TAG(state) {
        state.searchPayload.search_filters.search_keywords = '';
    },

    INIT_SEARCH_PAYLOAD(state, keepOpen) {
        state.searchPayload.search_filters = { ...state.searchPayload.search_filters, ...state.initSearchCriteria };
        if (keepOpen) {
            state.activeSearchFilter = true;
        }
    },

    STORE_SEARCH_FILTER_OCCUPATION(state, attributeOption) {
        const searchFilterCategories = state.searchPayload.search_filters.categories[0];
        if (!searchFilterCategories.occupations) {
            searchFilterCategories.occupations = [];
        }
        const index = searchFilterCategories.occupations.findIndex(o => o.id === attributeOption.id);
        if (index < 0) {
            state.searchPayload.search_filters.page = 1;
            searchFilterCategories.occupations.push(attributeOption);
            state.emitSearchFilterCount += 1;
        } else {
            searchFilterCategories.occupations.splice(index, 1);
            if (searchFilterCategories.id === 0) {
                state.searchPayload.search_filters.categories = [];
            }
            state.emitSearchFilterCount -= 1;
        }
    },

    STORE_SEARCH_FILTER_LOCATION(state, attributeOption) {
        if (state.searchPayload.search_filters?.location?.id && state.searchPayload.search_filters.location.id === parseInt(attributeOption.id)) {
            delete state.searchPayload.search_filters.location_id;
            state.searchPayload.search_filters.location = {};
            state.emitSearchFilterCount -= 1;
        } else {
            state.searchPayload.search_filters.page = 1;
            state.searchPayload.search_filters.location_id = attributeOption.id;
            state.emitSearchFilterCount += 1;
        }
    },


    DELETE_CLASSIFICATION(state, { id }) {
        const index = state.searchPayload.search_filters.classifications.findIndex(o => o.id === id);
        if (index >= 0) {
            state.searchPayload.search_filters.classifications.splice(index, 1);
            state.emitSearchFilterCount -= 1;
        }
    },

    DELETE_SUB_CLASSIFICATION(state, { id }) {
        const searchFilters = state.searchPayload.search_filters;
        if (searchFilters.classifications.length) {
            searchFilters.classifications.forEach((c, key) => {
                const index = c.subclassifications.findIndex(o => o.id === id);
                if (index >= 0) {
                    if (searchFilters.classifications[key].subclassifications.length === 1) {
                        searchFilters.classifications.splice(key, 1);
                    } else {
                        searchFilters.classifications[key].subclassifications.splice(index, 1);
                    }

                    state.emitSearchFilterCount -= 1;
                }
            });
        }
    },

    DELETE_LOCATION(state) {
        delete state.searchPayload.search_filters.location_id;
        state.searchPayload.search_filters.location = {};
        state.emitSearchFilterCount -= 1;
    },

    SET_LOADING_JOBS(state, data) {
        state.loading.jobs = data;
    },

    SET_MAPVIEW_JOBS_TOTAL(state, data) {
        state.mapView.total = data;
    },
};
